// Shared by Contacts.tsx's Online Pending/Dismissed pagination — both clamp
// their current page against a server-reported `totalPages` (from
// listAssistantObservationsPaginated) identically, after every poll/refetch/
// dismissal. A no-op whenever totalPages grows or stays the same (a new
// incoming message never forces the page back down); only pulls the current
// page back when it would otherwise exceed the new totalPages (e.g.
// dismissing the last item on the final page).
export function clampPage(page: number, totalPages: number): number {
  return Math.min(page, totalPages);
}
